import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import { Avatar, Typography, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import { important } from '../../utils/global/helper';

type Props = {
  linkName: string;
  linkRoute: string;
  isActive: boolean;
  icon: string;
  onNavigate?: () => void;
  badgeCount?: number;
};

function NavLink({
  linkName,
  linkRoute,
  isActive,
  icon,
  onNavigate,
  badgeCount = 0,
}: Props) {
  const theme = useTheme();
  return (
    <ListItem
      key={linkName}
      disablePadding
      className={isActive ? 'active' : ''}>
      <ListItemButton to={linkRoute} component={Link} onClick={onNavigate}>
        <ListItemIcon>
          <img src={icon} alt="icon" />
        </ListItemIcon>
        <ListItemText
          sx={{
            flexGrow: 0,
          }}>
          <Typography variant="body2">{linkName}</Typography>
        </ListItemText>
        {badgeCount > 0 && (
          <ListItemAvatar
            sx={{
              ml: '10px',
              width: 'fit-content',
              minWidth: 'unset',
            }}>
            <Avatar
              sx={{
                bgcolor: theme.palette.primary.main,
                p: 0.2,
                width: 20,
                height: 20,
                aspectRatio: 1,
                color: 'white',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <Typography
                variant="inherit"
                textAlign="center"
                sx={{
                  fontSize: badgeCount > 99 ? '0.6rem' : '0.65rem',
                  color: important('#ffffff'),
                  fontWeight: '600',
                }}>
                {badgeCount > 99 ? '99+' : badgeCount}
              </Typography>
            </Avatar>
          </ListItemAvatar>
        )}
      </ListItemButton>
    </ListItem>
  );
}

export default NavLink;
